import { extractErrorMessage, get, patch, post, put } from "src/helpers/api_helper"
import { IGeneralConfiguration, IToken, ResponseRequest } from "./types";

export const getGeneralConfigurations = async (): Promise<ResponseRequest<IGeneralConfiguration>> => {
    try {
        const response = await get<IGeneralConfiguration>('/generalConfigurations')
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const updateGeneralConfigurations = async (value: Partial<IGeneralConfiguration>): Promise<ResponseRequest<IGeneralConfiguration>> => {
    try {
        const response = await patch<IGeneralConfiguration>('/generalConfigurations', value)
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}